import { useQuery, UseQueryOptions } from "react-query";
import { FeatureCollection, Geometry, GeoJsonProperties } from "geojson";
import axios from "axios";

import { WFSGetFeatureParams } from "../types";

export function useWFSGetFeature<P>(
  url = "/geoserver/wfs",
  params: WFSGetFeatureParams,
  options?: UseQueryOptions<
    FeatureCollection<Geometry, P & GeoJsonProperties>,
    unknown,
    FeatureCollection<Geometry, P & GeoJsonProperties>,
    string[]
  >
) {
  async function fetch() {
    const defaultParams: Partial<WFSGetFeatureParams> = {
      count: 100,
      request: "GetFeature",
      service: "WFS",
      version: "2.0",
      outputFormat: "application/json",
      srsName: "EPSG:4326",
    };
    const config = {
      params: { ...defaultParams, ...params },
    };

    const { data } = await axios.get<
      FeatureCollection<Geometry, P & GeoJsonProperties>
    >(url, config);
    return data;
  }

  return useQuery(
    ["wfs-get-feature", url, JSON.stringify(params)],
    fetch,
    options
  );
}
